/*
 ** increment the currentValue by "i" (positive or negative) but find the nearest multiple of "i"
 ** i.e.
 ** 16 incremented by 15 would return 30
 ** 12 increment by 15 would return 15
 */
export var incrementToNearestMultiple = function incrementToNearestMultiple(currentValue, i) {
  if (isNaN(parseInt(currentValue)) || isNaN(parseInt(i))) {
    return currentValue;
  }
  i = parseInt(i);
  currentValue = parseInt(currentValue);
  var result = void 0;
  var modulo = currentValue % i;
  if (i > 0) {
    result = currentValue + i - modulo;
  } else {
    result = modulo > 0 ? currentValue - modulo : currentValue + i;
  }
  return result;
};

/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export var random = function random(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
};
//# sourceMappingURL=number.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/number.js
// module id = 382
// module chunks = 0